import { useNavigate } from "react-router-dom";
import { APP_MODE } from "@/config";
import { useAssessmentStore } from "@/service/assessment";
import { useUserStore } from "@/service/user";
import { ROUTES } from "@/shared/constants";
import { Button, Modal } from "@/shared/ui";

interface ConfirmLogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ConfirmLogoutModal = (props: ConfirmLogoutModalProps) => {
  const { isOpen, onClose } = props;
  const { logout } = useUserStore();
  const { resetStore } = useAssessmentStore();
  const navigate = useNavigate();

  const onLogoutClick = () => {
    if (APP_MODE === "ASSESSMENT") {
      resetStore();
    }
    // выход через Microsoft: стор чистится сразу, затем страница уходит на logout-редирект
    void logout();
    navigate(ROUTES.LOGIN);
    onClose();
  };

  return (
    <Modal active={isOpen} onClose={onClose}>
      <div className="max-w-full min-w-[400px] rounded-[10px] bg-white p-5">
        <div className="font-family-second text-eerie-black text-center text-2xl/[120%] tracking-[-0.02em]">
          Are you sure you want to exit?
        </div>
        <div className="mt-6 flex items-center justify-center gap-2.5">
          <Button appearance="primary" fullWidth onClick={onClose}>
            Cancel
          </Button>
          <Button appearance="danger" fullWidth onClick={onLogoutClick}>
            Exit
          </Button>
        </div>
      </div>
    </Modal>
  );
};
